import { render, staticRenderFns } from "./EntitiesList.vue?vue&type=template&id=02852ffa&"
import script from "./EntitiesList.vue?vue&type=script&lang=js&"
export * from "./EntitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EntitiesList.vue"
export default component.exports